<template>
  <div
    class="page-content"
    :style="{'background': background, 'padding': padding, 'margin': margin}"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'PageContent',
  props: {
    background: {
      type: String,
      default: '#ffffff'
    },
    padding: {
      type: String,
      default: '20px'
    },
    margin: {
      type: String,
      default: '15px'
    }
  }
}
</script>
<style lang="scss" scoped>
.page-content{
  border-radius: 6px;
}
</style>
